import Vue from "vue";
import Vuex from "vuex";
import API from "../api";

const _ = require("lodash");

Vue.use(Vuex);

async function HandleError(callback) {
	try {
		await callback();
	} catch (e) {
		throw e.response.data;
	}
}
const Billboard = {
	namespaced: true,
	state: {
		posts: {	// paginatioin
			total: 0,
			list: []
		},
		post: {},
		list: []
	},
	mutations: {},
	actions: {
		async getAllPosts({ state }) {
			await HandleError(async () => {
				let arr = (await API.getAllPosts()).data;
				state.list = arr.map(item => {
					return {
						...item,
						imgUrl: item.pictures[0].url || require("@/assets/news-default.jpg")
					}
				});
			});
		},
		async getPosts({ state }, query) {
			await HandleError(async () => {
				state.posts = (await API.getPosts(query)).data;
			});
		},
		async createPost({ state }, { query, data }) {
			await HandleError(async () => {
				state.posts = (await API.createPost(query, data)).data;
			});
		},
		async updatePost({ state }, { query, data }) {
			await HandleError(async () => {
				state.posts = (await API.updatePost(query, data)).data;
			});
		},
		async deletePost({ state }, { query, id }) {
			await HandleError(async () => {
				state.posts = (await API.deletePost(query, id)).data;
			});
		}
	}
};

export default Billboard;